// Generated by Melange

import * as Curry from "melange.js/curry.jsx";
import * as Ppx_deriving_json_runtime from "melange-json.ppx-runtime/ppx_deriving_json_runtime.jsx";

function of_json(a_of_json, x) {
  if (!(typeof x === "object" && !Array.isArray(x) && x !== null)) {
    Ppx_deriving_json_runtime.of_json_error("expected a JSON object");
  }
  const v = x["subsonic-response"];
  return {
    response: v !== undefined ? Curry._1(a_of_json, v) : Ppx_deriving_json_runtime.of_json_error("missing field \"subsonic-response\"")
  };
}

function to_json(a_to_json, x) {
  return {
    "subsonic-response": Curry._1(a_to_json, x.response)
  };
}

export {
  of_json,
  to_json,
}
/* No side effect */
